// Color variables

export const MAIN_COLOR = '#212121';
export const SECONDARY_COLOR = '#9B9FAA';
export const TEXT_COLOR = '#FFFFFF';
export const BACKGROUND_COLOR = '#E5E5E5';
export const SIDEBAR_COLOR = '#F0F1F3';
export const SIDEBAR_TEXT_COLOR = '#9B9FAA';
export const BUTTON_COLOR = '#FC842D';
export const LINE_COLOR = '#E0E0E0';
export const INTAKE_DAILY_COLOR = '#264061';

// Text variables

export const TITLE_FONTSIZE_MOB = '18px';
export const TITLE_FONTSIZE = '34px';

export const SUBTITLE_FONTSIZE_MOB = '18px';
export const SUBTITLE_FONTSIZE_DESC = '26px';

export const TEXT_FONTSIZE = '14px';
